// useStepAudioContext.js (Vue 3 compatible)

const audioCtx = new(window.AudioContext || window.webkitAudioContext)();
const audioBuffers = new Map(); // Cache for decoded buffers
const delay = ms => new Promise(resolve => setTimeout(resolve, ms))
let isMuted = false;
let currentSource = null;
// Schedule every clip a beat ahead of "now": a source started at exactly
// currentTime on a context that has just resumed loses its first tens of
// milliseconds, which clipped the opening word of walkthrough narration.
const LEAD_IN = 0.12; // seconds

export default {
    install(app) {
        app.config.globalProperties.$stepAudio = {
            isMuted: () => isMuted,
            mute: () => {
                isMuted = true;
            },
            unmute: () => {
                isMuted = false;
            },

            unlockAudioContext() {
                if (audioCtx.state === 'suspended') {
                    audioCtx.resume();
                }
            },

            async preload(url) {
                if (audioBuffers.has(url)) return audioBuffers.get(url);
                const res = await fetch(url);
                const arrayBuffer = await res.arrayBuffer();
                const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);
                audioBuffers.set(url, audioBuffer);
                return audioBuffer;
            },
            async play(url, delaytime = 0) {
                console.log('play', url, delaytime);
                if (isMuted) return;
                try {
                    // A suspended context swallows the first tens of
                    // milliseconds after start(): resume() is asynchronous
                    // and unlockAudioContext() never waited for it. Wait
                    // here so the clip's first word is not clipped.
                    if (audioCtx.state !== 'running') {
                        try { await audioCtx.resume(); } catch (err) { /* autoplay policy: play() below will warn */ }
                    }
                    let buffer = await this.preload(url);
                    let source = audioCtx.createBufferSource();
                    if (delaytime) {
                        setTimeout(async () => {
                        let gainNode = audioCtx.createGain();
                        gainNode.gain.value = delaytime == 11 ? 0.001 : 0.5;
                        console.log('gain', gainNode.gain.value);
                        buffer = await this.preload(url);
                        source.buffer = buffer;
                        source.connect(gainNode);
                        gainNode.connect(audioCtx.destination);
                        source.start(audioCtx.currentTime + LEAD_IN);
                        currentSource = source;
                        }, delaytime)
                    } else {
                        source.buffer = buffer;
                        source.connect(audioCtx.destination);
                        source.start(audioCtx.currentTime + LEAD_IN);
                        currentSource = source;
                    }
                } catch (err) {
                    console.warn('Audio playback failed:', err);
                }
            },

            stop() {
                if (currentSource) {
                    try {
                        currentSource.stop(0);
                        currentSource.disconnect();
                    } catch (err) {
                        console.warn('Audio stop failed:', err);
                    }
                    currentSource = null;
                }
            },

            pause() {
                if (audioCtx.state === 'running') {
                    audioCtx.suspend();
                }
            },

            resume() {
                if (audioCtx.state === 'suspended') {
                    audioCtx.resume();
                }
            },

            clearCache() {
                audioBuffers.clear();
            }
        };
    }
};
